"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tinymce_react_1 = require("@tinymce/tinymce-react");
require("tinymce/tinymce"); // core
require("tinymce/icons/default");
require("tinymce/themes/silver");
require("tinymce/models/dom");
// Import the plugins you need
require("tinymce/plugins/advlist");
require("tinymce/plugins/autolink");
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/charmap");
require("tinymce/plugins/preview");
require("tinymce/plugins/anchor");
require("tinymce/plugins/searchreplace");
require("tinymce/plugins/visualblocks");
require("tinymce/plugins/code");
require("tinymce/plugins/insertdatetime");
require("tinymce/plugins/table");
require("tinymce/plugins/wordcount");
const editorStyle_1 = __importDefault(require("../../hooks/editorStyle"));
const CustomTextEditor = ({ editorValue = "", setEditorValue, initialWidth, initialHeight, initialX = 0, initialY = 0, fontFamily = "Arial", fontSize, textColor, backgroundColor, borderWidth = "0px", borderColor = "", borderRadius = "", isResizable = true, isDraggable = true, showToolbar = true, toolbarMode = "floating", customToolbar, placeholder = "", lineHeight, textAlign, minWidth, minHeight, maxWidth, maxHeight, text, borderWidthTop, borderWidthRight, borderWidthBottom, borderWidthLeft, radiusTopLeft, radiusTopRight, radiusBottomRight, radiusBottomLeft, }) => {
    const wrapperId = "my-editor-wrapper";
    const [borderProps, setBorderProps] = (0, react_1.useState)({
        color: borderColor,
        borderWidthTop: borderWidthTop,
        borderWidthRight: borderWidthRight,
        borderWidthBottom: borderWidthBottom,
        borderWidthLeft: borderWidthLeft,
        radiusTopLeft: radiusTopLeft,
        radiusTopRight: radiusTopRight,
        radiusBottomRight: radiusBottomRight,
        radiusBottomLeft: radiusBottomLeft,
    });
    // Update border props when props change
    (0, react_1.useEffect)(() => {
        setBorderProps({
            width: borderWidth,
            color: borderColor,
            radius: borderRadius,
        });
    }, [borderWidth, borderColor, borderRadius]);
    (0, react_1.useEffect)(() => {
        if (text) {
            setEditorValue && setEditorValue(text);
        }
    }, [text]);
    // Default toolbar configuration
    // Content styles with customizable properties
    const contentStyle = `
    
    .mce-content-body:focus { 
      outline: none; 
      box-shadow: none; 
    }
    .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
      content: "${placeholder}";
      color: #999;
      font-style: italic;
    }
  `;
    (0, editorStyle_1.default)(wrapperId);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { id: wrapperId, style: { height: "100%" }, children: (0, jsx_runtime_1.jsx)(tinymce_react_1.Editor, { licenseKey: "gpl", value: editorValue, inline: true, onEditorChange: (content) => setEditorValue && setEditorValue(content), init: {
                    base_url: "/tinymce",
                    suffix: ".min",
                    height: "100%",
                    width: "100%",
                    menubar: false,
                    statusbar: false,
                    branding: false,
                    plugins: [
                        "lists",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "code",
                        "insertdatetime",
                        "wordcount",
                    ],
                    toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat  | borderwidth bordercolor borderradius",
                    placeholder: placeholder,
                    setup: (editor) => {
                        editor.ui.registry.addButton("borderwidth", {
                            text: "Border Width",
                            onAction: () => {
                                editor.windowManager.open({
                                    title: "Border Width",
                                    body: {
                                        type: "panel",
                                        items: [
                                            { type: "input", name: "top", label: "Top" },
                                            { type: "input", name: "right", label: "Right" },
                                            { type: "input", name: "bottom", label: "Bottom" },
                                            { type: "input", name: "left", label: "Left" },
                                        ],
                                    },
                                    buttons: [
                                        { type: "cancel", text: "Close" },
                                        { type: "submit", text: "Apply", primary: true },
                                    ],
                                    initialData: {
                                        top: borderProps.borderWidthTop || "0px",
                                        right: borderProps.borderWidthRight || "0px",
                                        bottom: borderProps.borderWidthBottom || "0px",
                                        left: borderProps.borderWidthLeft || "0px",
                                    },
                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        setBorderProps((prev) => (Object.assign(Object.assign({}, prev), { borderWidthTop: data.top, borderWidthRight: data.right, borderWidthBottom: data.bottom, borderWidthLeft: data.left })));
                                        api.close();
                                    },
                                });
                            },
                        });
                        editor.ui.registry.addButton("borderradius", {
                            text: "Border Radius",
                            onAction: () => {
                                editor.windowManager.open({
                                    title: "Border Radius",
                                    body: {
                                        type: "panel",
                                        items: [
                                            { type: "input", name: "topLeft", label: "Top Left" },
                                            { type: "input", name: "topRight", label: "Top Right" },
                                            { type: "input", name: "bottomRight", label: "Bottom Right" },
                                            { type: "input", name: "bottomLeft", label: "Bottom Left" },
                                        ],
                                    },
                                    buttons: [
                                        { type: "cancel", text: "Close" },
                                        { type: "submit", text: "Apply", primary: true },
                                    ],
                                    initialData: {
                                        topLeft: borderProps.radiusTopLeft || "0px",
                                        topRight: borderProps.radiusTopRight || "0px",
                                        bottomRight: borderProps.radiusBottomRight || "0px",
                                        bottomLeft: borderProps.radiusBottomLeft || "0px",
                                    },
                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        setBorderProps((prev) => (Object.assign(Object.assign({}, prev), { radiusTopLeft: data.topLeft, radiusTopRight: data.topRight, radiusBottomRight: data.bottomRight, radiusBottomLeft: data.bottomLeft })));
                                        api.close();
                                    },
                                });
                            },
                        });
                        editor.ui.registry.addButton("bordercolor", {
                            text: "Border Color",
                            onAction: () => {
                                editor.windowManager.open({
                                    title: "Border Color",
                                    body: {
                                        type: "panel",
                                        items: [{ type: "colorinput", name: "bordercolor", label: "Border Color" }],
                                    },
                                    buttons: [
                                        { type: "cancel", text: "Close" },
                                        { type: "submit", text: "Apply", primary: true },
                                    ],
                                    initialData: {
                                        bordercolor: borderProps.color || "#000000",
                                    },
                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        setBorderProps((prev) => (Object.assign(Object.assign({}, prev), { color: data.bordercolor })));
                                        api.close();
                                    },
                                });
                            },
                        });
                    }
                } }) }) }));
};
exports.default = CustomTextEditor;
